import {
    FontWeights,
    IconButton,
    //DefaultButton,
    Modal,
    PrimaryButton,
    TextField,
    getTheme,
    mergeStyleSets,
} from "@fluentui/react";
import { Spinner, SpinnerSize } from "@fluentui/react/lib/Spinner";
import { Stack } from "@fluentui/react/lib/Stack";
import { styles } from "components/dialogs/employees/styles";
import { cancelIcon } from "constants/styles";
import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import { Col, Row } from "react-grid-system";
import {
    useDispatch,
    useSelector
} from "react-redux";
import { AppState } from "store";
import * as Yup from "yup";
import VinScanner from "../../barCodeScanner/VinScanner.js";
//import { getVehicleVinEditPermission } from "utils/permissions/permissionsHelpers";
import { Link } from "@fluentui/react/lib/Link";
import dropDownsValues from "constants/inventoryDropdownsValues";
import { Dropdown as PRDropdown } from 'primereact/dropdown';
import { handleGetAppraisalVehDetails } from "store/oneDaySale/oneDaySale.action";

interface IProps {
    onDismiss: (res) => void;
    isOpen,
    addVehicleSectionIndex?: () => void;
    onVinEdit?: () => void;
}

const yearValues = dropDownsValues.yearNewValues.map((item) => {
    return { key: item, text: item };
});

export const EditVehicleAppraisalDialog: React.FunctionComponent<IProps> = ({
    onDismiss,
    isOpen,
    onVinEdit,
    addVehicleSectionIndex,
}) => {
    const loading = useSelector((state: AppState) => state.employees.loading);
    //const user = useSelector((state: AppState) => state.userProfile.userProfile) as any;
    const [isVINScan, setisVINScan] = useState(false);
    const dispatch = useDispatch();
    const [vinDataError, setvinDataError] = useState(false);
    const selectedOneDaySaleTradeIn = useSelector(
        (state: AppState) => state.oneDaySale.selectedOneDaySaleTradeIn
    );



    const formik = useFormik({
        initialValues: {
            vin: selectedOneDaySaleTradeIn?.vehicle.vin,
            year: selectedOneDaySaleTradeIn?.vehicle.year,
            make: selectedOneDaySaleTradeIn?.vehicle.make,
            model: selectedOneDaySaleTradeIn?.vehicle.model
        },
        validationSchema: Yup.object({
            year: Yup.string(),
            make: Yup.string(),
            model: Yup.string()

        }),
        onSubmit: (values) => {

            let ymm = {
                make: formik.values.make,
                model: formik.values.model,
                year: formik.values.year,
            };
            if(formik.values.vin ){
                ymm['vin'] = formik.values.vin;
             }
    
            dispatch<any>(handleGetAppraisalVehDetails({    
                vehDet:ymm,
                callback: (success) => {
                    if (success.id) {
                         onDismiss('')
                    }
                }
            }));

            }
    });



    const handleYearChange = (value) => {
        formik.setValues(
            {
                ...formik.values,
                year: value ? value : '',
            }
        );
    };
    const handleEditVehicleFlow = () => {
        addVehicleSectionIndex()
    };


    useEffect(() => {
        formik.setValues(
            {
                ...formik.values,
                "vin": selectedOneDaySaleTradeIn?.vehicle.vin,
            },
        );
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedOneDaySaleTradeIn])

    const renderSpinner = () => {
        return loading ? (
            <Spinner styles={styles.spinnerStyles} size={SpinnerSize.medium} />
        ) : null;
    };

    const changeToUppercase = (e: any) => {
        const re = /^[a-zA-Z0-9]*$/;

        if (e.target.value === '' || re.test(e.target.value)) {
            //this.setState({ value: e.target.value })
            formik.setFieldValue("vin", e.target.value.trim().toUpperCase());
        }
    };

    const handleUpdateDeal = () => {
        formik.handleSubmit()
    }

    const handleScanVIN = (bool) => {
        if (selectedOneDaySaleTradeIn?.vehicle?.vin && selectedOneDaySaleTradeIn?.vehicle?.vin !== '') {
            // On disabled scenario
        } else {
            setvinDataError(false);
            setisVINScan(bool)
        }
    }

    const onDismissModal = () => {
        if (isVINScan) {
            handleScanVIN(false);
        }
        else {
            onDismiss('')
        }
    }

    const onScanSubmit = (vin) => {
        let capturedVIN = vin.split(',');
        // When scanned with QR Code, contains multiple options. so picking VIn data alone
        let truncatedVIn = capturedVIN[0];
        if (capturedVIN[0].length === 18) {
            // When contains LEADING letter I
            truncatedVIn = capturedVIN[0].substring(1);
        }
        formik.setFieldValue("vin", truncatedVIn.trim().toUpperCase());
        handleScanVIN(false);
    }

    return (
        <>
            <Modal
                    isOpen={isOpen}
                    onDismiss={onDismissModal}
                    isBlocking={true}
                    styles={{ root: { zIndex: 10 } }}
                    className="createDealRecord vehicleInfoHeights updateEmployeeDialogHeight"
                    containerClassName={`${contentStyles.container} inv-srch-mod ${isVINScan ? 'scanner' : ''}`}
                >
                    <div className={contentStyles.header + " inventory-popup"}>
                        <h1 className="formTitle">Edit Vehicle Info</h1>
                        <IconButton
                            styles={iconButtonStyles}
                            iconProps={cancelIcon}
                            ariaLabel="Close popup modal"
                            onClick={onDismiss}
                        />
                    </div>
                    <div>{
                        vinDataError ?
                            <div>
                                <Row>
                                    <Col>
                                        <p className="genericErrorColor"><span>VIN is not recognized, please re-enter VIN.</span></p>
                                    </Col>
                                </Row>
                            </div> : null
                    }
                    </div>
                    {isVINScan ?
                        (<VinScanner onScanSubmit={(vin) => onScanSubmit(vin)} />)
                        :
                        <>
                            <div className={contentStyles.body} >
                                <Stack>
                                
                                    <Row className="inventoryRowSection" justify="center">
                                        <Col md={9} >
                                            <div className="yearMake">
                                                <h5 className="primeDropdownLabel" style={selectedOneDaySaleTradeIn?.vehicle?.isAddedByVin ? { color: 'gray', margin: "5px 0" } : { margin: "5px 0" }} >Year</h5>
                                                <PRDropdown
                                                    id="model_addInventory"
                                                    value={formik.values.year}
                                                    className="invMakeDropdown labelTextBorder full-width"
                                                    options={yearValues}
                                                    onChange={(e) => handleYearChange(e.value)}
                                                    optionLabel="text"
                                                    optionValue="text"
                                                    scrollHeight="150px"
                                                    virtualScrollerOptions={{ itemSize: 31 }}
                                                    disabled={selectedOneDaySaleTradeIn?.vehicle?.isAddedByVin}
                                                    placeholder="Select a Year"
                                                    appendTo="self"
                                                    filter
                                                    resetFilterOnHide={true}
                                                    required={true} />
                                            </div>
                                        </Col>
                                    </Row>
                                    <Row justify="center">
                                        <Col md={9} >
                                            <TextField
                                                id="make"
                                                name="make"
                                                label="Make"
                                                placeholder=""
                                                autoComplete="off"
                                                value={formik.values.make}
                                                //required={true}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                disabled={selectedOneDaySaleTradeIn?.vehicle?.isAddedByVin}
                                            /* errorMessage={
                                                formik.touched && formik.touched.make &&
                                                formik.errors && formik.errors.make &&
                                                formik.errors.make.toString()
                                            } */
                                            />
                                        </Col>
                                    </Row><Row justify="center">
                                        <Col md={9} >
                                            <TextField
                                                id="model"
                                                name="model"
                                                label="Model"
                                                placeholder=""
                                                autoComplete="off"
                                                value={formik.values.model}
                                                //required={true}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                disabled={selectedOneDaySaleTradeIn?.vehicle?.isAddedByVin}
                                            /* errorMessage={
                                                formik.touched && formik.touched.model &&
                                                formik.errors && formik.errors.model &&
                                                formik.errors.model.toString()
                                            } */
                                            />
                                        </Col>
                                    </Row>
                                    <Row justify="center">
                                        <Col md={9} >
                                            {
                                                selectedOneDaySaleTradeIn?.vehicle?.isAddedByVin ?
                                                    <>
                                                        <div>
                                                            <div style={{ width: "180px" }}>
                                                                <TextField
                                                                    id="vin"
                                                                    name="vin"
                                                                    label="VIN"
                                                                    iconProps={{ iconName: "Camera", style: { pointerEvents: "auto", cursor: "pointer" }, onClick: () => handleScanVIN(true) }}
                                                                    value={formik.values.vin}
                                                                    disabled={true}
                                                                    onChange={changeToUppercase}
                                                                    onBlur={formik.handleBlur}
                                                                    errorMessage={
                                                                        formik.touched.vin &&
                                                                        formik.errors.vin &&
                                                                        formik.errors.vin.toString()
                                                                    }

                                                                />
                                                            </div>
                                                            <PrimaryButton
                                                                //disabled={!formik.dirty || !formik.isValid}
                                                                text="Edit"
                                                                onClick={onVinEdit}
                                                                className="vehicle-vin-edit-btn"
                                                            />
                                                        </div>
                                                    </> :
                                                    <>
                                                        <TextField
                                                            id="vin"
                                                            name="vin"
                                                            label="VIN"
                                                            iconProps={{ iconName: "Camera", style: { pointerEvents: "auto", cursor: "pointer" }, onClick: () => handleScanVIN(true) }}
                                                            value={formik.values.vin}
                                                            //disabled={(selectedOneDaySaleTradeIn?.vehicle?.vin) ? selectedOneDaySaleTradeIn?.vehicle.vin !== '' : false}
                                                            onChange={changeToUppercase}
                                                            onBlur={formik.handleBlur}
                                                            errorMessage={
                                                                formik.touched.vin &&
                                                                formik.errors.vin &&
                                                                formik.errors.vin.toString()
                                                            }
                                                        // style={{ width: "calc(100% - 130px)" }}
                                                        />
                                                    </>
                                            }
                                        </Col>
                                    </Row>
                                    <Row className="noVin" justify="center">
                                        <Col md={9}>
                                            <Link onClick={handleEditVehicleFlow} style={{ float: "right", marginTop: "10px" }}>
                                                {selectedOneDaySaleTradeIn?.vehicle?.isAddedByVin ? "Add vehicle manually" : "Add vehicle by VIN"}
                                            </Link>
                                        </Col>
                                    </Row>
                                </Stack>
                            </div>
                            <div className={contentStyles.footer}>
                                <Stack tokens={styles.buttonTokens} horizontal horizontalAlign="center">

                                    <PrimaryButton
                                        //disabled={!formik.dirty || !formik.isValid}
                                        onRenderIcon={renderSpinner}
                                        text="Save"
                                        onClick={handleUpdateDeal}
                                    />
                                </Stack>
                            </div>
                        </>
                    }
                </Modal>
            
   
        </>

    );
};

const theme = getTheme();
const contentStyles = mergeStyleSets({
    container: {
        // width: "50%",
        width: 400,
        // display: 'flex',
        // flexFlow: 'column nowrap',
        // alignItems: 'stretch',
        zIndex: 100,
    },
    header: {
        flex: "1 1 auto",
        borderTop: `4px solid ${theme.palette.themePrimary}`,
        color: theme.palette.neutralPrimary,
        display: "flex",
        alignItems: "center",
        fontWeight: FontWeights.semibold,
        padding: "5px 30px",
    },

    body: {
        // flex: "4 4 auto",
        // padding: "0 24px 24px 24px",
        //   padding: '75px',
        paddingLeft: 30,
        paddingRight: 30,
        paddingBottom: "34px",
        // overflowY: "hidden",
        selectors: {
            p: { margin: "14px 0" },
            "p:first-child": { marginTop: 0 },
            "p:last-child": { marginBottom: 0 },
        },
    },
    footer: {
        padding: "0px 30px",
        paddingBottom: 15,
    },
});
const iconButtonStyles = {
    root: {
        color: theme.palette.neutralPrimary,
        marginLeft: "auto",
        marginTop: "4px",
        marginRight: "2px",
    },
    rootHovered: {
        color: theme.palette.neutralDark,
    },
};
